export const HELPLINE_NUMBER = '+91 8143869980';

export const SOURCE = {
        WEBSITE: "WEBSITE",
        MOBILE_APP: "MOBILE_APP",
}

export const STUDENT_STATUS = {
        ONBOARDED: "ONBOARDED",
        INPROGRESS: "INPROGRESS",
        COMPLETED: "COMPLETED",
}

export const PROFILES = {
        ADMIN: "ADMIN",
        ORGANIZATION: "ORGANIZATION",
        DEALER: "DEALER",
        AGENT: "AGENT",
        DRIVER: "DRIVER",
        STUDENT: "STUDENT",
}

export const REFERRAL_STATUS = {
        PENDING: "PENDING",
        ELIGIBLE: "ELIGIBLE",
        AWAITING_PAYMENT: "AWAITING_PAYMENT",
        PAID_BOTH: "PAID_BOTH",
        EXPIRED: "EXPIRED",
}

export const REFERRAL_PAYMENT_STATUS = {
        PENDING: "PENDING",
        PAID: "PAID",
}

export const BLOOD_GROUPS = {
        A_POSITIVE: "A+",
        A_NEGATIVE: "A-",
        B_POSITIVE: "B+",
        B_NEGATIVE: "B-",
        AB_POSITIVE: "AB+",
        AB_NEGATIVE: "AB-",
        O_POSITIVE: "O+",
        O_NEGATIVE: "O-",
}